import script from "./ElaAdminSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ElaAdminSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ElaAdminSidebar.vue?vue&type=style&index=0&id=6ec82703&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec82703"]])

export default __exports__